import {
    lsApiService,
    lsErrorService,
    lsStorageService,
    lsStorageServiceConstants,
} from 'ls-vue-common';
import {
    AUTH__JWT_FETCH,
    AUTH__JWT_IS_LOADING,
    AUTH__JWT_MUTATE,
    AUTH__JWT_RECEIVED,
    AUTH__JWT,
} from '@/store/types';

const createInitialState = () => {
    return {
        token: lsStorageService.get(lsStorageServiceConstants.AUTH_TOKEN),
        user: {
            customer: {},
        },
        loadingStatus: {
            isInitializing: false,
            isLoading: false,
            isUpdating: false,
        },
    };
};

export const mutations = {
    [AUTH__JWT_IS_LOADING](state, { isLoading }) {
        state.isLoading = isLoading;
    },

    [AUTH__JWT_MUTATE](state, { jwt }) {
        state.jwt = `Bearer ${jwt}`;
    },
};

export const actions = {
    [AUTH__JWT_FETCH]({ commit, dispatch }) {
        commit(AUTH__JWT_IS_LOADING, { isLoading: true });
        return lsApiService
            .request({ route: '/auth/partnersapi/token', method: 'POST' })
            .then(({ token }) => dispatch(AUTH__JWT_RECEIVED, token))
            .catch((error) => lsErrorService.log({ error }))
            .finally(() => commit(AUTH__JWT_IS_LOADING, { isLoading: false }));
    },

    [AUTH__JWT_RECEIVED]({ commit }, token) {
        commit(AUTH__JWT_MUTATE, { jwt: token });
        lsStorageService.set(AUTH__JWT, token);
    },
};

export const auth = {
    state: createInitialState,
    mutations,
    actions,
};
